import { t } from "i18next";
import { validateIP } from "../../../helpers/functions/functions";

export const anycastError = (anycast) => {
  let error;
  const filteredAnycast = anycast.filter((a) => a !== "");

  if (filteredAnycast.length === 0) {
    error = [t("message.required", { item: t("site.anycast") })];
    filteredAnycast.push("");
  } else {
    const anycastError = [];
    let hasError = false;

    filteredAnycast.map((a, i) => {
      if (!validateIP(filteredAnycast[i]) && filteredAnycast[i] !== "") {
        anycastError[i] = t("message.format", { item: t("site.anycast") });
        hasError = true;
      }
    });

    if (hasError) {
      error = anycastError;
    }
  }

  return { error, filteredAnycast };
}